/* =====================================================================
   DEMO / MOCK DATA — NOT PRODUCTION
   Placeholder customer + booking history for the account screens.
   Invented. NOT real customers, NOT real bookings.
   Real data comes from Odoo (partner + appointments) via the API adapter.
   ===================================================================== */

export const DEMO_CUSTOMER = {
  id: 'cust-demo-1',
  name: { ar: 'ضيفة بيلا فيتا', en: 'Bella Vita guest' },
  phone: '0500000000',
  email: '',
};

export const DEMO_BOOKINGS = [
  {
    ref: 'BV-4837', dateISO: '2026-09-12', time: '17:30', status: 'upcoming',
    specialist: { ar: 'نورة', en: 'Noura' },
    services: [
      { name: { ar: 'قص شعر وتصفيف', en: 'Haircut & style' }, price: 140 },
      { name: { ar: 'منيكير كلاسيك', en: 'Classic manicure' }, price: 95 },
    ],
    total: 270,
  },
  {
    ref: 'BV-4712', dateISO: '2026-08-28', time: '14:00', status: 'completed',
    specialist: { ar: 'سارة', en: 'Sara' },
    services: [{ name: { ar: 'هايلايت / أومبريه', en: 'Highlights / ombré' }, price: 640 }],
    total: 736,
  },
  {
    ref: 'BV-4590', dateISO: '2026-08-05', time: '11:00', status: 'completed',
    specialist: { ar: '—', en: 'No preference' },
    services: [{ name: { ar: 'تنظيف بشرة عميق', en: 'Deep facial' }, price: 210 }],
    total: 241,
  },
];
